import {
  Level_INFO_getInstance1ztv8i0iil2fd as Level_INFO_getInstance,
  Level_ERROR_getInstance1k2olngvyukiu as Level_ERROR_getInstance,
} from './Level.mjs';
import { toStringSafe207d7m7lap1sq as toStringSafe } from './internal/MessageInvoker.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function info(message) {
  return this.p2f(null, null, message);
}
function info_0(throwable, message) {
  return this.p2f(null, throwable, message);
}
function info_1(marker, throwable, message) {
  var tmp = Level_INFO_getInstance();
  return this.w2f(tmp, marker, ($this$at) => {
    $this$at.r2f_1 = toStringSafe(message);
    $this$at.s2f_1 = throwable;
    return Unit_instance;
  });
}
function error(throwable, message) {
  return this.y2f(null, throwable, message);
}
function error_0(marker, throwable, message) {
  var tmp = Level_ERROR_getInstance();
  return this.w2f(tmp, marker, ($this$at) => {
    $this$at.r2f_1 = toStringSafe(message);
    $this$at.s2f_1 = throwable;
    return Unit_instance;
  });
}
var KLoggerClass;
function KLogger() {
  if (KLoggerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KLogger');
    KLoggerClass = $;
  }
  return KLoggerClass;
}
//region block: exports
export {
  error as error12wpw0xi3o0bs,
  error_0 as error1aa4zvb3h0fa3,
  info_1 as info2wxw456lwpd2r,
  info_0 as info2hxv79dt541ps,
  info as info3uezdutu3rpr2,
  KLogger as KLogger368y32iihya1v,
};
//endregion

//# sourceMappingURL=KLogger.mjs.map
